

















import {Component, Prop, Vue} from "vue-property-decorator";
import {PostOfficeStore} from "@/modules/postoffices/store";
import {PostOffice} from "@/interfaces/entity/postoffice";

@Component({
    name: "PostOfficeTableAction"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly postOfficeId!: string;

    get postOffice(): PostOffice {
        return PostOfficeStore.data[this.postOfficeId];
    }

    set postOffice(value: PostOffice) {
        PostOfficeStore.data[this.postOfficeId] = value;
    }
    async onConfirm() {
        try {
            await PostOfficeStore.deletePostOffice(this.postOfficeId);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa bưu cục thành công"
            });
        } catch (e) {
            console.log(e);
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa bưu cục thất bại"
            });
        }
    }
}
